import { Component, Input, OnInit, ElementRef, Output, EventEmitter, ContentChild, TemplateRef } from '@angular/core';

import { curveMonotoneX } from 'd3-shape';
import "core-js";
import { BehaviorSubject, combineLatest, interval, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { v4 as uuidv4 } from 'uuid';
import { ObservableInput } from 'ngx-observable-input';
import { LineChartOptions } from '../../GraphQL/LineChart/linechart.component';

import { NgxMultiExcludes } from '../../../operators/ngx/multi-excludes/ngx-multi-excludes.operator';
import { Multi } from '../../../interfaces/multi.interface';


@Component({
  selector: 'line-chart',
  templateUrl: './linechart.component.html',
  styleUrls: ['./linechart.component.css']
})
export class LineChartComponent implements OnInit {


  
  

  // options
  legend: boolean = true;
  legendTitle: string = "";
  legendPosition: string = 'bottom';
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = true;
  //xAxisLabel: string = 'Year';
  //yAxisLabel: string = 'Population';
  timeline: boolean = true;
  curve: any = curveMonotoneX;

  scheme = {
    domain: ['#00abca', '#be0078', '#85bf75', '#c23133']
  };



  @ObservableInput()
  @Input("results")
  results$: Observable<Multi[]>;
  _results: Observable<Multi[]>;
  

  @Input()
  options: LineChartOptions = null;

  @Output()
  select: EventEmitter<any> = new EventEmitter();

  @ContentChild('eveTooltipTemplate') eveTooltipTemplate: TemplateRef<any>;
  @ContentChild('eveSeriesTooltipTemplate') eveSeriesTooltipTemplate: TemplateRef<any>;
  

  

  excludeResults: BehaviorSubject<String[]> = new BehaviorSubject([]);

    
  parentWidth: Observable<number> = interval(10).pipe(
    map(() => {
      return this.parentElement.clientWidth;
    }),
    distinctUntilChanged()
  );

  parentHeight: Observable<number> = interval(10).pipe(
    map(() => {
      return this.parentElement.clientHeight;
    }),
    distinctUntilChanged()
  );

  view: Observable<number[]> = combineLatest(this.parentWidth, this.parentHeight).pipe(
    map(a => [a[0], a[1] - 15]),
    debounceTime(50),

  );

  parentElement: any = null;



  componenetId: String = "componenetId_" + uuidv4().replaceAll("-", "");

  constructor(
    private elRef: ElementRef,
    private sanitizer: DomSanitizer
  ) {

  }

  ngOnInit() {
    this.elRef.nativeElement.classList.add(this.componenetId);

    this.parentElement = this.elRef.nativeElement;

    this._results = this.results$.pipe(
      NgxMultiExcludes(this.excludeResults)
    );
  }

 

  legendStyles: Observable<SafeHtml> = this.excludeResults.pipe(
    map(excludeResult => {
      return this.sanitizer.bypassSecurityTrustHtml(excludeResult.map((e, p) => `<style>
      .${this.componenetId} ngx-charts-legend-entry [title="${e}"] {
        opacity: 0.2;
      }
    </style>`
      ).join("\r\n"))
    })
  );

  
  
  onSelect(data): void {
    //alert("hi");
    if (!this.isLegend(data)) {
      this.select.emit(data);
      //alert("not legend");
    } else {

      const excludeResults = this.excludeResults.getValue();
      //alert("legend");
      

      if (excludeResults.indexOf(data) == -1) this.excludeResults.next(excludeResults.concat([data]));
      else this.excludeResults.next(excludeResults.filter(i => i != data));
    }
  }

  /*
  onSelect(data): void {
    if (!this.isLegend(data)) {
      this.select.emit({ result: data, query: this.query });
    } else {
      const excludeResults = this.excludeResults.getValue()

      if (excludeResults.indexOf(data) == -1) this.excludeResults.next(excludeResults.concat([data]));
      else this.excludeResults.next(excludeResults.filter(i => i != data));
    }
  }*/


  isLegend = (event) => typeof event === 'string';



  onActivate(data): void {
  }

  onDeactivate(data): void {
  }

}








